export default __webpack_public_path__ + "static/media/icon_checkbox_off.5409f91e.svg";